import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import styled from 'styled-components';

import App from './App';
import MapView from './MapView';
import Introduction from './components/Introduction';


const GlobalMenu = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin: 0;
  list-style: none;
  border-bottom: 1px solid black;
  > * {
    margin: 0 0 0 1rem;
  }
`;

const GlobalMenuLink = styled(Link)`
  position: relative;
  display: flex;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  text-align: center;
  transition: all 0.24s ease 0s;
  font-weight: bold;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  justify-content: flex-end;
  text-decoration: none;
  &,
  &:visited {
    color: inherit;
  } 
  &.active,
  &:hover {
    color: #0686E5;
    background: rgba(101,121,252,0.08);
  }
`;

export default function BasicExample() {
  return (
    <Router>
      <div>
        <GlobalMenu>
          <li>
            <GlobalMenuLink to="/">
              <span>Map View</span>
            </GlobalMenuLink>
          </li>

          <li>
            <GlobalMenuLink to="/list-view">
              <span>List View</span>
            </GlobalMenuLink>
          </li>
        </GlobalMenu>

        <Introduction />

        <Switch>
          <Route exact path="/list-view">
            <App />
          </Route>

          <Route path="/">
            <MapView />
          </Route>
        </Switch>
      </div>
    </Router>
  )
}